/**
 * Created by maty on 14/02/2017.
 */
export enum GroupType {
    Guest               = 0,
    Viewer              = 1,
    Client              = 2,
    Collaborator        = 3,
    Manager             = 4,
    FullManager         = 5
}



// WEBPACK FOOTER //
// ./src/app/enums/group-type.enum.ts